export enum SearchType {
	Grocery = 'Grocery',
	Recipes = 'Recipes',
}
